export const OK_STATUS = 'ok';
export const OK_PARTIAL = 'ok_partial';
export const NO_ACTIVE_INTEGRATION = 'no_active_integrations';
export const FIRST_PULLING = 'first_pulling';
export const ALL_SOURCES_PULLING_ERR_OR_PULLING = 'all_sources_pulling_error_or_pulling';